import React, { useEffect, useState, useRef } from "react";
import "../../Styles/CommonStyles.scss";
import {
  Button,
  Label,
  PageLink,
  SecondaryWhiteButton,
} from "../StyledComp/StyledComp";
import DSBAlogo from "../../Images/DSBAlogo.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import eventApiSlice, { IEvent } from "../../store/eventApiSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import dayjs, { Dayjs } from "dayjs";
import ReportServices from "../../services/ReportServices";
import AlertWithModal from "../utilityComponents/AlertWithModal";
import { createTheme } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemeProvider } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

interface Iprops {
  //callBackClose: () => void;
}


interface MembershipData {
  TotalFee: number;
  TotalLateFee: number;
  TotalDueAmount: number;
  Checks: number;
  CC: number;
  SectionName: string;
  Id: number;
  OrderIds: number;
  NetAmount: number;
}



const ReconcileReport: React.FC<Iprops> = (props) => {
  const [totalSectionsFee, setTotalSectionsFee] = useState<number>(0);
  const [totalSectionsCC, setTotalSectionsCC] = useState<number>(0);
  const [totalSectionsChecks, setTotalSectionsChecks] = useState<number>(0);

  const [totalMembershipFee, setTotalMembershipFee] = useState<number>(0);
  const [totalMembershipCC, setTotalMembershipCC] = useState<number>(0);
  const [totalMembershipChecks, setTotalMembershipChecks] = useState<number>(0);

  const [totalDueFee, setTotalDueFee] = useState<number>(0);
  const [totalDueCC, setTotalDueCC] = useState<number>(0);
  const [totalDueChecks, setTotalDueChecks] = useState<number>(0);

  const [totalLateFeeFee, setTotalLateFeeFee] = useState<number>(0);
  const [totalLateFeeCC, setTotalLateFeeCC] = useState<number>(0);
  const [totalLateFeeChecks, setTotalLateFeeChecks] = useState<number>(0);

  const [summaryGrandTotalFee, setSummaryGrandTotalFee] = useState<number>(0);
  const [summaryGrandTotalChecks, setSummaryGrandTotalChecks] = useState<number>(0);
  const [summaryGrandTotalCC, setSummaryGrandTotalCC] = useState<number>(0);

  const [startDate, setStartDate] = useState<Dayjs | null>(dayjs(null));
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs(null));
  const BeforeReportRef = useRef<HTMLDivElement>(null);
  const AfterReportRef = useRef<HTMLDivElement>(null);
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const eventInfo: IEvent = useSelector(
    (state: RootState) => state.eventapislice.event
  );


  const [membershipData, setMembershipData] = useState<MembershipData[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);


  const color1 = "#2d6289"; // Use the same color as in FMPersonalInfo
  
  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        error: {
          main: color1,
        },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              borderBottomStyle: "solid",
              borderBottomWidth: 1,
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
              // Left: "-4%",
              // Top: "10%",
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
              Left: "-4% !important",
              Top: "10%",
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
      },
    });

    const fetchMembershipData = async (fromDate: string, toDate: string) => {
      setLoading(true);
      setError(null);
      try {
        const response = await ReportServices.fetchMembershipData(fromDate, toDate);

        if (response.data.data != null) {
          if (response.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response.data.errors[0].sqlMessage);
            return;
          }
          console.log("fetchMembershipData:", response.data.data);
          const data = response.data.data.sections;
          setMembershipData(response.data.data.sections);

          
          let totalFee = 0;
          let totalCC = 0;
          let totalChecks = 0;

          let totalDueFee = 0;
          let totalDueCC = 0;
          let totalDueChecks = 0;
          let dueOrderKey: number[] = [];

          let totalLateFeeFee = 0;
          let totalLateFeeCC = 0;
          let totalLateFeeChecks = 0;
          let lateFeeOrderKey: number[] = [];

          data.forEach((item: MembershipData) => {
            totalFee += item.TotalFee;
            totalCC += item.CC;
            totalChecks += item.Checks;


            if(item.CC > 0){
              if(dueOrderKey[item.OrderIds] === undefined){
                totalDueCC += item.TotalDueAmount;
                totalDueFee += item.TotalDueAmount;
                dueOrderKey[item.OrderIds] = 1;
              }

              if(lateFeeOrderKey[item.OrderIds] === undefined){
                totalLateFeeCC += item.TotalLateFee;
                totalLateFeeFee += item.TotalLateFee;
                lateFeeOrderKey[item.OrderIds] = 1;
              }
            }else{
              if(lateFeeOrderKey[item.OrderIds] === undefined){
                totalLateFeeChecks += item.TotalLateFee;
                totalLateFeeFee += item.TotalLateFee;
                lateFeeOrderKey[item.OrderIds] = 1;
              }

              if(dueOrderKey[item.OrderIds] === undefined){
                totalDueChecks += item.TotalDueAmount;
                totalDueFee += item.TotalDueAmount;
                dueOrderKey[item.OrderIds] = 1;
              }
            }
            


        
          });

          // Set the totals
          setTotalSectionsFee(totalFee);
          setTotalSectionsCC(totalCC);
          setTotalSectionsChecks(totalChecks);

          setTotalMembershipFee(response.data.data.membershipTotal);
          setTotalMembershipCC(response.data.data.membershipCCTotal);
          setTotalMembershipChecks(response.data.data.membershipCheckTotal);

          setTotalDueFee(totalDueFee);
          setTotalDueCC(totalDueCC);
          setTotalDueChecks(totalDueChecks);

          setTotalLateFeeFee(totalLateFeeFee);
          setTotalLateFeeCC(totalLateFeeCC);
          setTotalLateFeeChecks(totalLateFeeChecks);

          // Set grand totals 
          setSummaryGrandTotalFee(totalFee + totalDueFee + totalLateFeeFee + response.data.data.membershipTotal); 
          setSummaryGrandTotalChecks(totalChecks + totalDueChecks + totalLateFeeChecks + response.data.data.membershipCheckTotal); 
          setSummaryGrandTotalCC(totalCC + totalDueCC + totalLateFeeCC + response.data.data.membershipCCTotal); 

        } else {
          setError("Error fetching data: " + response.data.errors.join(","));
        }
      } catch (err) {
        setError("API call failed: " + err);
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      setStartDate(dayjs());
      setEndDate(dayjs());
    }, []);
  
    useEffect(() => {
      if (startDate && endDate) {
        console.log("startDate:", startDate);
        console.log("endDate:", endDate);
        const formattedStartDate = startDate.format('MM-DD-YYYY');
        const formattedEndDate = endDate.format('MM-DD-YYYY');
        fetchMembershipData(formattedStartDate, formattedEndDate);
      }
    }, [startDate, endDate]);

  const PrintLabelRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({ content: () => PrintLabelRef.current });

  return (
    <>
      <div
        className="horizontal-wrapper-spacebetween"
        style={{ alignItems: "center" }}
      >
        <h1 className="page-heading d-block" style={{ height: "auto" }}>
          Membership Accounting Report
        </h1>
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div className="reconcileReportDPContainer">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <ThemeProvider theme={muiDatePickerColorTheme}>
                <div className="reconcileReportDPContainer" style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                  <DatePicker
                    label="From"
                    value={startDate}
                    onChange={(newValue) => setStartDate(dayjs.isDayjs(newValue) ? newValue : dayjs(newValue))}
                    slotProps={{
                      textField: {
                        label: "From",
                        variant: "outlined",
                        size: "small",
                        style: { width: '200px' }
                      },
                    }}
                  />
                  <DatePicker
                    label="To"
                    value={endDate}
                    onChange={(newValue) => setEndDate(dayjs.isDayjs(newValue) ? newValue : dayjs(newValue))}
                    slotProps={{
                      textField: {
                        label: "To",
                        variant: "outlined",
                        size: "small",
                        style: { width: '200px' }
                      },
                    }}
                  />
                </div>
              </ThemeProvider>
            </LocalizationProvider>
          </div>
        </div>
        <div
          className="horizontal-wrapper-rightaligned"
          style={{
            width: "auto",
            marginLeft: "0px",
            marginRight: "0px",
          }}
        >
          <SecondaryWhiteButton
            className="button-wrapper"
            type="button"
            style={{
              marginRight: ".5rem",
              marginLeft: ".5rem",
            }}
            onClick={() => handlePrint()}
          >
            <span style={{ fontWeight: "500" }}>Print / Download</span>
          </SecondaryWhiteButton>
        </div>
        <div className="tableContainer" ref={PrintLabelRef}>
            <h1 className="print-header page-heading" style={{ height: "auto" }}>
              Membership Accounting Report ({startDate?.format('MM-DD-YYYY') + " to " + endDate?.format('MM-DD-YYYY')})
            </h1>
              <div style={{ width: "100%" ,paddingBottom: "5%" }}>
                <table
                  className="eventlist-table"
                  style={{ tableLayout: "fixed", width: "100%" }}
                >
                  <thead className="table-border">
                    <tr style={{ height: "auto", whiteSpace: "normal" }}>
                      <th style={{ width: "30%", textAlign: "left",background:"#04aa6d" }}>Name</th>
                      <th style={{ width: "20%", textAlign: "left",background:"#04aa6d" }}>Total</th>
                      <th style={{ width: "20%", textAlign: "left",background:"#04aa6d" }}>CC</th>
                      <th style={{ width: "30%", textAlign: "left",background:"#04aa6d" }}>Checks</th>
                    </tr>
                  </thead>
                  <tbody className="table-border">
                  {membershipData.map(item => (
                    <tr key={item.Id}>
                      <td style={{ textAlign: "left" }}>{item.SectionName}</td>
                      <td style={{ textAlign: "left" }}>{item.TotalFee}</td>
                      <td style={{ textAlign: "left" }}>{item.CC}</td>
                      <td style={{ textAlign: "left" }}>{item.Checks}</td>
                    </tr>
                  ))}
                  </tbody>
                  
                </table>
              <table className="eventlist-table" style={{ borderTop: 'none' }}>
                <tbody className="table-border">
                  <tr style={{ fontWeight: "bold" }}>
                    <td style={{ width: "30%", textAlign: "left" }}>Sections Total</td>
                    <td style={{ width: "20%", textAlign: "left" }}>{totalSectionsFee}</td>
                    <td style={{ width: "20%", textAlign: "left" }}>{totalSectionsCC}</td>
                    <td style={{ width: "30%", textAlign: "left" }}>{totalSectionsChecks}</td>
                  </tr>
                  <tr style={{ fontWeight: "bold" }}>
                    <td style={{ width: "30%", textAlign: "left" }}>Membership Total</td>
                    <td style={{ width: "20%", textAlign: "left" }}>{totalMembershipFee}</td>
                    <td style={{ width: "20%", textAlign: "left" }}>{totalMembershipCC}</td>
                    <td style={{ width: "30%", textAlign: "left" }}>{totalMembershipChecks}</td>
                  </tr>
                  <tr style={{ fontWeight: "bold" }}>
                    <td style={{ width: "30%", textAlign: "left" }}>Due Total</td>
                    <td style={{ width: "20%", textAlign: "left" }}>{totalDueFee}</td>
                    <td style={{ width: "20%", textAlign: "left" }}>{totalDueCC}</td>
                    <td style={{ width: "30%", textAlign: "left" }}>{totalDueChecks}</td>
                  </tr>
                  <tr style={{ fontWeight: "bold" }}>
                    <td style={{ width: "30%", textAlign: "left" }}>Late Fee Total</td>
                    <td style={{ width: "20%", textAlign: "left" }}>{totalLateFeeFee}</td>
                    <td style={{ width: "20%", textAlign: "left" }}>{totalLateFeeCC}</td>
                    <td style={{ width: "30%", textAlign: "left" }}>{totalLateFeeChecks}</td>
                  </tr>
                  <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}>
                    <td style={{ width: "30%", textAlign: "left" }}><strong>Summary Grand Total</strong></td>
                    <td style={{ width: "20%", textAlign: "left" }}><strong>{summaryGrandTotalFee}</strong></td>
                    <td style={{ width: "20%", textAlign: "left" }}><strong>{summaryGrandTotalCC}</strong></td>
                    <td style={{ width: "30%", textAlign: "left" }}><strong>{summaryGrandTotalChecks}</strong></td>
                  </tr>
                </tbody>
              </table>

              </div>
        </div>
      </div>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </>
  );
};
export default ReconcileReport;
